import { StoreState } from '@/core/models/store.interface';
import i18n from '@/i18n';
import { Module } from 'vuex';
import { Preference } from './preference.interface';
import preferenceService from './preference.service';

export interface PreferenceState {
   preferences: Array<Preference>;
}

const PreferenceStore: Module<PreferenceState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async update(
         context,
         {
            preferenceable_type,
            preferenceable_id,
            preference_type_key,
            value,
         }: { preferenceable_type: string; preferenceable_id: number; preference_type_key: string; value: any },
      ) {
         const BODY = { preferenceable_type, preferenceable_id, preference_type_key, value };
         return await preferenceService.update(BODY).then(() => {
            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'success',
                     message: i18n.global.t('board.setting_saved'),
                  },
               },
               { root: true },
            );
         });
      },
   },
};

export default PreferenceStore;
